import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

// bind images
  imgAvatar = 'images/hendyghsta.jpg';

  constructor() { }

  ngOnInit() {
  }

}
